"use client"

import { useState, useCallback } from "react"
import { Col, Container, Row } from "reactstrap"
import Breadcrumbs from "../../../CommonElements/Breadcrumbs/Breadcrumbs"
import MenuList from "./menu-list"
import MenuModal from "./menu-modal"
import MenuDetailModal from "./menu-detail-modal"
import type { Menu } from "../rolemanagement/types"

const MenuContainer = () => {
  const [modalOpen, setModalOpen] = useState(false)
  const [detailModalOpen, setDetailModalOpen] = useState(false)
  const [selectedMenu, setSelectedMenu] = useState<Menu | null>(null)
  const [refreshTrigger, setRefreshTrigger] = useState(false)

  const handleOpenAdd = useCallback(() => {
    setSelectedMenu(null)
    setModalOpen(true)
  }, [])

  const handleOpenEdit = useCallback((menu: Menu) => {
    setSelectedMenu(menu)
    setModalOpen(true)
  }, [])

  const handleOpenView = useCallback((menu: Menu) => {
    setSelectedMenu(menu)
    setDetailModalOpen(true)
  }, [])

  const handleSuccess = useCallback(() => {
    setModalOpen(false)
    setDetailModalOpen(false)
    setRefreshTrigger((prev) => !prev)
  }, [])

  const handleCloseModal = useCallback(() => {
    setModalOpen(false)
    setSelectedMenu(null)
  }, [])

  const handleCloseDetailModal = useCallback(() => {
    setDetailModalOpen(false)
    setSelectedMenu(null)
  }, [])

  return (
    <>
      <Breadcrumbs mainTitle="Menu Management" parent="Administration" />
      <Container fluid>
        <Row>
          <Col md="12">
            <MenuList
              onAdd={handleOpenAdd}
              onEdit={handleOpenEdit}
              onView={handleOpenView}
              refreshTrigger={refreshTrigger}
            />
          </Col>
        </Row>

        {/* Menu Create/Edit Modal */}
        <MenuModal isOpen={modalOpen} onClose={handleCloseModal} onSuccess={handleSuccess} initialData={selectedMenu} />

        {/* Menu Detail Modal */}
        <MenuDetailModal isOpen={detailModalOpen} onClose={handleCloseDetailModal} menu={selectedMenu} />
      </Container>
    </>
  )
}

export default MenuContainer
